import React from 'react'

export default function CircleIcon({ ...props }) {
    return (
        <svg {...props} viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="8" cy="8.02808" r="6" stroke="#858383" stroke-width="2" />
            <circle cx="8" cy="8.02808" r="2" fill="#858383" />
        </svg>
    )
}